import { render, staticRenderFns } from "./FinanceStudentView.vue?vue&type=template&id=57a4cca5"
import script from "./FinanceStudentView.vue?vue&type=script&lang=js"
export * from "./FinanceStudentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports